import corporateHealthService from "services/corporate-health.service";

export async function processInvite(code) {
  const { data: h } = await corporateHealthService.getEventInviteDetailsByCode(
    code
  );

  return {
    invite: {
      ...h,
      logo: "https://dnjqko642wsuu.cloudfront.net/email/logo_zennya_health_blue.png",
    },
  };
}
